import initHomeHero from './components/home-hero';
import initAnnouncement from './components/announcement';
import initHomeHighlights from './components/home-highlights';
import initLatestNews from './components/latest-news';

const heroEl = document.querySelector('.js-home-hero');

if (heroEl) {
    initHomeHero(heroEl);
}

const announcement = document.querySelector('.js-announcement');

if (announcement) {
    initAnnouncement(announcement);
}

const highlightsEl = document.querySelector('.js-home-highlights');

if (highlightsEl) {
    initHomeHighlights(highlightsEl);
}

const latestNews = document.querySelectorAll('.js-latest-news');

if (latestNews && latestNews.length > 0) {
    initLatestNews(latestNews);
}
